// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@conklin/App/Components/Common/XngZone";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

export interface NavListLayoutLayout {
    container?: InjectableCss;
    navWrapper?: InjectableCss;
    pageTitleWrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
}

export const navListLayoutLayout: NavListLayoutLayout = {};

const styles = navListLayoutLayout;
const NavListLayout: FC<WidgetProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="My-Account-Details-Pages-Layout">
            <StyledWrapper {...styles.navWrapper}>
                <XngZone contentId={id} zoneName="Content01" hint="Zone For Nav List" />
            </StyledWrapper>
            <StyledWrapper {...styles.pageTitleWrapper}>
                <XngZone contentId={id} zoneName="Content02" hint="Zone For Page Title" />
            </StyledWrapper>
            <StyledWrapper {...styles.contentWrapper}>
                <XngZone contentId={id} zoneName="Content03" hint="Zone For Content" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: NavListLayout,
    definition: {
        group: "Layout" as any,
        displayName: "Page includes Navigation List Layout",
    },
};

export default widgetModule;
